import { en as reactEn } from '@ews/react-translations';


const en = {
  ...reactEn,

  "[REACT_LOGOUT]": "Manual logout",
  "[REACT_LOGOUT_DIALOG_CONTENT]": "Do you really want to manually log out this user?",
  "COM_FACPMANAGEMENT_USER_ACCOUNT_NOTIFICATIONS_MAILS": "E-Mail notifications at",
  "[SID_DLG_HEADER_SIMULATIONEND]": "Terminate simulation",
  "[REACT_SIMULATE_USER]": "Simulate user login",
  "[CONFIRM_SIMULATE_USER]": "Are you sure you want to simulate logging in as this user?",
  "[REACT_SIMULATION_STARTING]": "Starting Simulation",
  "[REACT_SIMULATION_ACTIVE]": "Simulation",
  "[REACT_SIMULATION_ENDING]": "Terminating simulation",
  "[REACT_CREATE_SYSTEM_SHARE_DURATION]": "Duration",
  "[REACT_CREATE_SYSTEM_SHARE_INTERVALL]": "Time interval",
};

export default en;
